import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent, type Analytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCVPjnbzk9W3C1nDMYZuDR1N0hAyH9ST9w',
  authDomain: 'dadaplugins-1fdbf.firebaseapp.com',
  projectId: 'dadaplugins-1fdbf',
  storageBucket: 'dadaplugins-1fdbf.firebasestorage.app',
  messagingSenderId: '443215198216',
  appId: '1:443215198216:web:08a40585dbda8b7c0b79bd',
  measurementId: 'G-6WFELTF13J',
};

const app = initializeApp(firebaseConfig);
let analyticsPromise: Promise<Analytics | null> | undefined;

export function getFirebaseAnalytics(): Promise<Analytics | null> {
  analyticsPromise ??= isSupported()
    .then((supported) => (supported ? getAnalytics(app) : null))
    .catch(() => null);

  return analyticsPromise;
}

export async function trackFirebasePageView(path: string, title: string): Promise<void> {
  const analytics = await getFirebaseAnalytics();
  if (!analytics) return;

  logEvent(analytics, 'page_view', {
    page_location: window.location.href,
    page_path: path,
    page_title: title,
  });
}
